export const classes = {
  cell: 'select-none text-sm text-grey-7 font-medium py-4 bg-grey-1 border-b border-grey-3',
};
